import React, { ReactElement } from 'react';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import { Outlet } from 'react-router-dom';

import { ModuleDeclaration } from '../ModuleDeclaration';

import EditWebhook from './EditWebhook/EditWebhook';
import IntegrationsContainer from './IntegrationsContainer/IntegrationsContainer';


const IntegrationsWrapper = (props: any): JSX.Element => {
  const element = withAuthenticationRequired(Outlet)(props);
  return element! as ReactElement;
};

const IntegrationsRouteProperties: ModuleDeclaration = {
  routeProps: {
    path: '/integrations',
    element: <IntegrationsWrapper />,
    children: [
      { index: true, element: <IntegrationsContainer /> },
      { path: '/integrations/webhooks/edit/:id', element: <EditWebhook /> }
    ],
  },
  name: 'Integrations',
  isHidden: false,
  containerCss: 'mb-5 border-bottom',
  iconClassName: 'bi bi-link-45deg',
};

export default IntegrationsRouteProperties;
